module.exports = __webpack_public_path__ + "static/media/IM.bdd79441.svg";